/* ck-no-match-popup.js — auto-generated by Google Apps Script */
(function () {

  // ── Config ───────────────────────────────────────────────
  var REDIRECT_BASE  = "https://worthwrap.in/discount/CASEKARO?redirect=/collections/all-mix-designs";
  var TRACKER_URL    = "https://script.google.com/macros/s/AKfycbwXiQCucz0OEoIopRf6cj1W27xm3we0NXZ_H_uW7c9edD-JKW4MGHAtA-FzHh1a6pbN_w/exec";
  var PARTNER_NAME   = "WorthWrap";
  var PRODUCT_IMAGES = ["https://cdn.shopify.com/s/files/1/0054/8349/5522/files/WorthWrap001.avif","https://cdn.shopify.com/s/files/1/0054/8349/5522/files/WorthWrap002.avif","https://cdn.shopify.com/s/files/1/0054/8349/5522/files/WorthWrap003.avif"];
  var DELAY          = 800;
  var UTM_SOURCE     = "casekaro";
  var UTM_MEDIUM     = "popup";
  var UTM_CAMPAIGN   = "no-match-skin";

  var SEEN_KEY    = "ck_nm_seen";
  var MATCH_KEY   = "ck_nm_match";
  var VARIANT_KEY = "ck_nm_variant";

  // ── No-match map: hardwareCode → modelName ───────────────
  var MAP = {"infinix x6873":"Infinix GT 30 Pro 5G","v2407":"Vivo Y28e 5G","cph2761":"Oppo K13 Turbo 5G","v2513":"Vivo V60e","a069":"Nothing Phone (4a)","motorola edge 70 fusion":"Moto Edge 70 Fusion","rmx5003":"Realme Narzo 70 Turbo 5G","cph2565":"Oppo A78 4G","rmx3750":"Realme Narzo 60","v2538":"Vivo V70","sm-e176b/ds":"Samsung F17","25098ra98i":"Redmi Note 15 5G","i2223":"iQOO Z7s","sm-e346b":"Samsung F34","cph2825":"Oppo Reno15","sm-m366b":"Samsung M36","sm-m366b/ds":"Samsung M36","moto g57 power":"Moto G57 Power","xt2537-5":"Moto G57 Power","v2561":"vivo X200T","rmx5108":"Realme P4x 5G","i2508":"iQOO 15R","24095pcadi":"POCO X7","rmx5033":"Realme Narzo 80 Pro 5G","rmx3461":"Realme 9 5G Speed","rmx5131":"Realme 16 Pro+","moto g67 power 5g":"Moto G67 Power","rmx5032":"Realme P3 Pro 5G","rmx3031":"Realme GT Neo","rmx5120":"Realme 16 Pro","rmx5085":"Realme GT 7T","i2207":"iQOO Z7","v2504":"Vivo T4 Ultra","sm-a066b":"Samsung A06","sm-a066b/ds":"Samsung A06","2412dpc0ag":"Poco X7 Pro","2412dpc0ai":"Poco X7 Pro","x689b":"Infinix Hot 10S","x689":"Infinix Hot 10S","x689d":"Infinix Hot 10S","infinix x689":"Infinix Hot 10S","moto g31":"Moto G31/G41","x6816c":"Infinix Hot 12 Play","x6816":"Infinix Hot 12 Play","infinix x6816c":"Infinix Hot 12 Play","motorola edge 20 fusion":"Moto Edge 20 Fusion 5G","moto e40":"Moto e40","pixel 4":"Google Pixel 4","g020m":"Google Pixel 4","g020i":"Google Pixel 4","ga01188-us":"Google Pixel 4","ga01187-us":"Google Pixel 4","ga01189-us":"Google Pixel 4","ga01191-us":"Google Pixel 4","moto g73 5g":"Moto G73 5G","moto g72":"Moto G72","motorola edge 30 fusion":"Moto Edge 30 Fusion","v2355":"Vivo Y58 5G","rmx5070":"Realme 14","v2443":"Vivo Y39 5G","v2436":"Vivo Y39 5G","moto g86 power 5g":"Moto G86 Power","xt2527-7":"Moto G86 Power","rmx5101":"Realme 15 Pro","rmx5110":"Realme P4","a024":"Nothing Phone 3","24108pce2i":"Poco M7 5G","mzb0ke1in":"Poco M7 5G","25057rn09i":"Redmi 15 5G","sm-e146b":"Samsung F14","sm-e146b/ds":"Samsung F14","i2220":"iQOO 12","i2018":"iQOO Z5 5G","rmx3943":"Realme C75 5G","v2548":"Vivo V70 Elite","sm-e566b":"Samsung F56","sm-e566b/ds":"Samsung F56","x6870":"Infinix Note 50s","infinix x6870":"Infinix Note 50s","2312frafdi":"Poco X6 Neo","tecno lj8k":"Tecno Pova Curve 5G","lj8":"Tecno Pova Curve 5G","lj8k":"Tecno Pova Curve 5G","sm-s731b":"Samsung S25 FE 5G","sm-s731b/ds":"Samsung S25 FE 5G","sm-s731w":"Samsung S25 FE 5G","sm-s731u":"Samsung S25 FE 5G","sm-s731u1":"Samsung S25 FE 5G","sm-s731n":"Samsung S25 FE 5G","sm-s7310":"Samsung S25 FE 5G","v2037":"Vivo Y20G","v2065":"Vivo Y20G","infinix x6871":"Infinix GT 20 Pro","x6871":"Infinix GT 20 Pro","infinix x6851":"Infinix Note 40 Pro 5G","cph2693":"Oppo A3 5G","v2117":"Vivo Y75 4G","rmx5107":"Realme P4 Power 5G","i2126":"iQOO Z6 Pro 5G","rmx3945":"Realme C73 5G","cph2325":"Oppo A55","cph2813":"Oppo Reno15 Pro Mini","infinix x6857b":"Infinix Note 50x 5G+","i2012":"iQOO 7 5G","cph2733":"Oppo A5x 5G","cph2823":"Oppo A6x 5G","rmx5061":"Realme GT 7","pixel 10a":"Google Pixel 10a","infinix x6739":"Infinix GT 10 Pro 5G","25080rabdi":"Redmi Note 15 Pro 5G","2510era8bi":"Redmi Note 15 Pro 5G","cph2461":"Oppo F21s Pro 4G","23027rad4i":"Redmi Note 12 4G","rmx3761":"Realme Narzo N53","sm-e225f":"Samsung F22","i2409":"iQOO Z10 Lite 5G","i2501":"iQOO 15 5G","cph2785":"Oppo A6 5G","sm-a127f":"Samsung A12","sm-a125f":"Samsung A12","rmx5250":"Realme 15x 5G","v2143":"Vivo T1x","sm-x115":"Samsung Galaxy Tab A9","25028pc03i":"Poco C71","sm-a042f":"Samsung A04e","cph2827":"Oppo A6 Pro 5G","cph2801":"Oppo Reno15 F 5G","cph2375":"Oppo A76","infinix x6731":"Infinix Zero 30 5G","cph2739":"Oppo Reno14 Pro 5G","sm-f966b":"Samsung Galaxy Z Fold6","tecno lh8n":"Tecno Pova 5 Pro 5G"};

  // ── Suppressed paths ─────────────────────────────────────
  var SUPPRESSED_PATHS = ["/cart","/checkout","/account","/pages/phone-cases-by-model","/pages/predict","/pages/glass-phone-cases-by-model"];

  // ── Copy variants ────────────────────────────────────────
  var VARIANTS = [
    { icon: "😔", l1: "No case for your {m} yet...",      l2: "Cases coming soon — grab a skin in the meantime!" },
    { icon: "🚀", l1: "Your {m} is on our radar!",        l2: "Cases dropping soon. Till then, skins from our partner." },
    { icon: "⏳", l1: "Cases for {m} — coming soon!",     l2: "Don't wait — our partner has skins for your phone." },
    { icon: "🎯", l1: "Spotted: {m}. Cases in progress!", l2: "Keep it scratch-free with a skin while you wait." },
    { icon: "💡", l1: "No {m} case? No problem.",         l2: "Our partner's skins fit your phone perfectly." },
    { icon: "🛍️", l1: "Your {m} deserves better.",        l2: "Cases coming soon — skins available now!" }
  ];

  // ── Build redirect URL with UTM + model content tag ──────
  function buildRedirectUrl(modelName) {
    var slug = modelName.toLowerCase().replace(/[^a-z0-9]+/g, "-").replace(/^-|-$/, "");
    var sep  = REDIRECT_BASE.indexOf("?") !== -1 ? "&" : "?";
    return REDIRECT_BASE
      + sep
      + "utm_source="   + encodeURIComponent(UTM_SOURCE)
      + "&utm_medium="  + encodeURIComponent(UTM_MEDIUM)
      + "&utm_campaign=" + encodeURIComponent(UTM_CAMPAIGN)
      + "&utm_content=" + encodeURIComponent(slug);
  }

  // ── Suppression ───────────────────────────────────────────
  function isSuppressed() {
    var path = window.location.pathname.toLowerCase();
    for (var i = 0; i < SUPPRESSED_PATHS.length; i++) {
      if (path === SUPPRESSED_PATHS[i] || path.indexOf(SUPPRESSED_PATHS[i] + "/") === 0) return true;
    }
    return false;
  }

  // ── Tracking — fills col G (shown) or H (clicked) ────────
  function trackEvent(eventName) {
    var sessionId = localStorage.getItem('ck_session_id') || '';
    if (!sessionId) return;
    try {
      fetch(TRACKER_URL, {
        method: 'POST',
        mode: 'no-cors',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ event: eventName, session_id: sessionId })
      });
    } catch (e) {}
  }

  // ── Session variant ───────────────────────────────────────
  function getVariant() {
    var stored = sessionStorage.getItem(VARIANT_KEY);
    if (stored !== null) return parseInt(stored);
    var idx = Math.floor(Math.random() * VARIANTS.length);
    sessionStorage.setItem(VARIANT_KEY, String(idx));
    return idx;
  }

  // ── Inject styles ─────────────────────────────────────────
  function injectStyles() {
    if (document.getElementById("ck-nm-s")) return;
    var s = document.createElement("style"); s.id = "ck-nm-s";
    s.textContent = [
      "@keyframes cknmUp{from{opacity:0;transform:scale(0.95)}to{opacity:1;transform:scale(1)}}",
      "@keyframes cknmShimmer{0%{background-position:0%}100%{background-position:300%}}",
      "@keyframes cknmPulse{0%,100%{box-shadow:0 0 0 0 rgba(255,107,53,0.5)}70%{box-shadow:0 0 0 10px rgba(255,107,53,0)}}",

      // Overlay
      "#ck-nm-overlay{position:fixed;inset:0;background:rgba(0,0,0,0.6);z-index:99999;display:flex;align-items:center;justify-content:center;padding:16px;}",

      // Card
      "#ck-nm-card{background:#fff;border-radius:20px;border:2px solid #ff6b35;box-shadow:0 0 0 6px rgba(255,107,53,0.12),0 24px 60px rgba(0,0,0,0.4);width:100%;max-width:340px;overflow:hidden;position:relative;animation:cknmUp .4s cubic-bezier(.4,0,.2,1);}",
      "#ck-nm-card *{box-sizing:border-box;font-family:sans-serif}",

      // Shimmer bar
      "#ck-nm-shimmer{height:4px;background:linear-gradient(90deg,#ff6b35,#ff9f1c,#ff6b35);background-size:300%;animation:cknmShimmer 3s linear infinite}",

      // Close button
      "#ck-nm-close{position:absolute;top:11px;right:11px;background:#fff5f2;border:1.5px solid #ffd5c8;color:#ff6b35;font-size:13px;cursor:pointer;line-height:1;padding:5px 9px;border-radius:8px;font-weight:800;z-index:2}",

      // Heading
      "#ck-nm-heading{display:flex;align-items:flex-start;gap:10px;margin-bottom:14px;padding-right:42px}",
      "#ck-nm-icon{width:42px;height:42px;border-radius:12px;background:#fff5f2;border:1.5px solid #ffd5c8;display:flex;align-items:center;justify-content:center;flex-shrink:0;font-size:22px;line-height:1}",
      "#ck-nm-l1{font-size:13px;color:#111;font-weight:800;margin:0 0 4px;line-height:1.35}",
      "#ck-nm-l1 .ck-nm-m{color:#ff6b35;background:#fff5f2;padding:1px 5px;border-radius:5px}",
      "#ck-nm-l2{font-size:12px;color:#555;margin:0;line-height:1.4}",

      // Coming soon badge
      "#ck-nm-badge{background:linear-gradient(135deg,#fff8e1,#fff3cc);border:1px solid #ffe082;border-radius:10px;padding:8px 12px;margin-bottom:12px;display:flex;align-items:center;gap:8px}",
      "#ck-nm-badge p{font-size:12px;color:#b8600b;font-weight:700;margin:0;line-height:1.3}",
      "#ck-nm-badge .ck-nm-soon{color:#e65100;font-size:14px;font-weight:800}",

      // Product grid (mirrors main popup)
      "#ck-nm-prods .pr{display:flex;align-items:center;justify-content:space-between;margin-bottom:8px}",
      "#ck-nm-prods .pl{font-size:12px;color:#111;margin:0;font-weight:700}",
      "#ck-nm-prods .sa{font-size:10px;color:#ff6b35;text-decoration:none;font-weight:700;white-space:nowrap}",
      "#ck-nm-prods .gr{display:grid;grid-template-columns:repeat(3,minmax(0,1fr));gap:6px;margin-bottom:10px}",
      "#ck-nm-prods .gr a{text-decoration:none;min-width:0}",
      "#ck-nm-prods .pc{background:#fafafa;border-radius:9px;overflow:hidden;border:1.5px solid #eef4ff;min-width:0}",
      "#ck-nm-prods .pc.pop{border-color:#ff6b35}",
      "#ck-nm-prods .pb{background:#ff6b35;text-align:center;padding:3px 0;font-size:8px;color:#fff;font-weight:800;letter-spacing:.06em}",
      "#ck-nm-prods .pi{width:100%;height:110px;background:#fff;overflow:hidden;display:flex;align-items:center;justify-content:center;padding:4px}",
      "#ck-nm-prods .pi img{width:100%;height:100%;object-fit:contain;display:block}",
      "#ck-nm-prods .pn{font-size:9px;color:#888;margin:4px 6px 2px;white-space:nowrap;overflow:hidden;text-overflow:ellipsis}",
      "#ck-nm-prods .pp{display:flex;align-items:center;gap:3px;padding:0 6px 6px}",
      "#ck-nm-prods .pri{font-size:11px;color:#111;margin:0;font-weight:700}",

      // CTA button
      "#ck-nm-btn{display:flex;align-items:center;justify-content:center;gap:6px;background:#ff6b35;color:#fff;text-decoration:none;font-weight:800;padding:14px 12px;border-radius:11px;letter-spacing:.01em;animation:cknmPulse 2s ease-out infinite;margin-bottom:8px;white-space:nowrap;overflow:hidden;text-overflow:ellipsis}",
      "#ck-nm-btn:hover{background:#e55a27}",

      // Notify me link
      "#ck-nm-notify{text-align:center;padding:2px 0 2px}",
      "#ck-nm-notify a{font-size:11px;color:#aaa;text-decoration:none}",
      "#ck-nm-notify a span{color:#4a90d9;font-weight:600}",

      // Draggable bubble
      "#ck-nm-bubble{position:fixed;bottom:16px;right:14px;z-index:99999;background:#ff6b35;border-radius:50px;padding:9px 14px;cursor:grab;display:none;align-items:center;gap:7px;box-shadow:0 4px 16px rgba(255,107,53,.4);user-select:none;touch-action:none}",
      "#ck-nm-bubble:hover{background:#e55a27}",
      "#ck-nm-bubble .bl{font-size:9px;color:rgba(255,255,255,.8);margin:0;line-height:1.2}",
      "#ck-nm-bubble .bm{font-size:11px;color:#fff;font-weight:800;margin:0;line-height:1.2}",
      "#ck-nm-bubble .ba{font-size:11px;color:rgba(255,255,255,.7)}"
    ].join("");
    document.head.appendChild(s);
  }

  // ── Draggable bubble helper ───────────────────────────────
  function clamp(v, mn, mx) { return Math.min(Math.max(v, mn), mx); }

  function makeDraggable(el) {
    function start(cx, cy) { var r = el.getBoundingClientRect(); el._sx = cx; el._sy = cy; el._ol = r.left; el._ot = r.top; el._dr = true; el.style.cursor = "grabbing"; }
    function move(cx, cy)  { if (!el._dr) return; var r = el.getBoundingClientRect(); var L = clamp(el._ol + cx - el._sx, 4, window.innerWidth - r.width - 4); var T = clamp(el._ot + cy - el._sy, 4, window.innerHeight - r.height - 4); el.style.position = "fixed"; el.style.left = L + "px"; el.style.top = T + "px"; el.style.right = "auto"; el.style.bottom = "auto"; }
    function end()         { if (!el._dr) return; el._dr = false; el.style.cursor = "grab"; sessionStorage.setItem("ck_nm_bl", el.style.left); sessionStorage.setItem("ck_nm_bt", el.style.top); }
    el.addEventListener("mousedown", function(e) { start(e.clientX, e.clientY); });
    document.addEventListener("mousemove", function(e) { move(e.clientX, e.clientY); });
    document.addEventListener("mouseup", end);
    el.addEventListener("touchstart", function(e) { var t = e.touches[0]; start(t.clientX, t.clientY); }, { passive: true });
    document.addEventListener("touchmove", function(e) { if (el._dr) { var t = e.touches[0]; move(t.clientX, t.clientY); e.preventDefault(); } }, { passive: false });
    document.addEventListener("touchend", end);
  }

  function makeBubble(modelName, onTap) {
    if (document.getElementById("ck-nm-bubble")) return document.getElementById("ck-nm-bubble");
    injectStyles();
    var b = document.createElement("div"); b.id = "ck-nm-bubble";
    b.innerHTML = "<span style=\"font-size:16px;line-height:1;\">🎁</span><div><p class=\"bl\">Skin for your</p><p class=\"bm\">" + modelName + "</p></div><span class=\"ba\">↑</span>";
    makeDraggable(b);
    var sl = sessionStorage.getItem("ck_nm_bl"), st = sessionStorage.getItem("ck_nm_bt");
    if (sl && st) { b.style.position = "fixed"; b.style.left = sl; b.style.top = st; b.style.right = "auto"; b.style.bottom = "auto"; }
    b.addEventListener("click", function(e) {
      if (Math.abs(e.clientX - (b._sx || 0)) < 6 && Math.abs(e.clientY - (b._sy || 0)) < 6) { onTap(); }
    });
    document.body.appendChild(b);
    return b;
  }

  // ── Build & show popup card ───────────────────────────────
  function buildCard(modelName, redirectUrl) {
    injectStyles();

    var vi = getVariant();
    var v  = VARIANTS[vi];
    var l1Html = v.l1.replace("{m}", "<span class=\"ck-nm-m\">" + modelName + "</span>");

    // Dynamic button font size — keep to 1 line
    var totalLen = ("🛍️ Grab " + modelName + " Skins →").length;
    var btnFs = totalLen > 36 ? "10px" : totalLen > 30 ? "11px" : totalLen > 24 ? "12px" : "14px";

    var overlay = document.createElement("div"); overlay.id = "ck-nm-overlay";
    var card    = document.createElement("div"); card.id = "ck-nm-card";

    // Shimmer bar
    var shim = document.createElement("div"); shim.id = "ck-nm-shimmer";
    card.appendChild(shim);

    // Track popup shown
    trackEvent('no_match_shown');

    // Bubble (persists for session)
    var bubble = makeBubble(modelName, function () {
      overlay.style.display = "flex";
      bubble.style.display  = "none";
    });
    bubble.style.display = "none";

    // Close button → show bubble
    var cl = document.createElement("button"); cl.id = "ck-nm-close"; cl.innerHTML = "✕";
    cl.addEventListener("click", function () {
      overlay.style.display = "none";
      bubble.style.display  = "flex";
    });
    card.appendChild(cl);

    // Inner padding wrapper
    var inner = document.createElement("div"); inner.style.cssText = "padding:14px 14px 0 14px;";

    // Heading row
    var hrow = document.createElement("div"); hrow.id = "ck-nm-heading";
    hrow.innerHTML =
      "<div id=\"ck-nm-icon\">" + v.icon + "</div>" +
      "<div style=\"min-width:0;flex:1;\"><p id=\"ck-nm-l1\">" + l1Html + "</p><p id=\"ck-nm-l2\">" + v.l2 + "</p></div>";
    inner.appendChild(hrow);

    // Coming soon badge (compact, like social proof in main popup)
    var badge = document.createElement("div"); badge.id = "ck-nm-badge";
    badge.innerHTML =
      "<span style=\"font-size:18px;line-height:1;\">🔥</span>" +
      "<p><span class=\"ck-nm-soon\">COMING SOON</span> &nbsp;" + modelName + " cases are in the works!</p>";
    inner.appendChild(badge);

    // Product grid — 3 WorthWrap skin images, all link to redirectUrl
    var sec = document.createElement("div"); sec.id = "ck-nm-prods";
    sec.innerHTML = "<div class=\"pr\"><p class=\"pl\">Skins for your " + modelName + " ✨</p><a href=\"" + redirectUrl + "\" class=\"sa\" target=\"_blank\" rel=\"noopener\">See all →</a></div>";
    var gr = document.createElement("div"); gr.className = "gr";
    var labels = ["TRENDING", "POPULAR", "NEW"];
    PRODUCT_IMAGES.forEach(function (imgSrc, i) {
      var a = document.createElement("a"); a.href = redirectUrl; a.target = "_blank"; a.rel = "noopener";
      a.innerHTML =
        "<div class=\"pc" + (i === 1 ? " pop" : "") + "\">" +
        "<div class=\"pb\">" + labels[i] + "</div>" +
        "<div class=\"pi\"><img src=\"" + imgSrc + "\" alt=\"\" loading=\"lazy\"></div>" +
        "<p class=\"pn\">" + PARTNER_NAME + " Skin</p>" +
        "<div class=\"pp\"><p class=\"pri\">View →</p></div></div>";
      a.addEventListener("click", function () { window.ckTrack && window.ckTrack('no_match_clicked'); overlay.style.display = "none"; bubble.style.display = "flex"; });
      gr.appendChild(a);
    });
    sec.appendChild(gr);
    inner.appendChild(sec);
    card.appendChild(inner);

    // CTA button area
    var bw = document.createElement("div"); bw.style.cssText = "padding:10px 14px 14px;";

    var btn = document.createElement("a"); btn.id = "ck-nm-btn"; btn.href = redirectUrl; btn.target = "_blank"; btn.rel = "noopener";
    btn.style.fontSize = btnFs;
    btn.innerHTML = "🛍️ Grab " + modelName + " Skins →";
    btn.addEventListener("click", function () {
      window.ckTrack && window.ckTrack('no_match_clicked');
      overlay.style.display = "none";
      bubble.style.display  = "flex";
    });
    bw.appendChild(btn);

    // Browse all link
    var notify = document.createElement("div"); notify.id = "ck-nm-notify";
    notify.innerHTML = "<a href=\"https://casekaro.com/pages/phone-cases-by-model\">Not your phone? <span>Browse all cases →</span></a>";
    bw.appendChild(notify);

    card.appendChild(bw);
    overlay.appendChild(card);
    document.body.appendChild(overlay);
  }

  // ── Show popup or bubble ──────────────────────────────────
  function showForModel(modelName, redirectUrl) {
    if (isSuppressed()) return;

    setTimeout(function () {
      window.ckTrack && window.ckTrack('no_match_shown');
      if (!sessionStorage.getItem(SEEN_KEY)) {
        sessionStorage.setItem(SEEN_KEY, "1");
        buildCard(modelName, redirectUrl);
      } else {
        // Already seen this session — show bubble only
        if (!document.getElementById("ck-nm-bubble")) {
          var b = makeBubble(modelName, function () {
            b.style.display = "none";
            sessionStorage.removeItem(SEEN_KEY);
            buildCard(modelName, redirectUrl);
          });
          b.style.display = "flex";
        }
      }
    }, DELAY);
  }

  // ── Device detection ──────────────────────────────────────
  function detect(hw) {
    if (!hw) return;
    var key = hw.toLowerCase().trim();
    var modelName = MAP[key];
    if (!modelName) return;  // Not in no-match list — exit silently

    var redirectUrl = buildRedirectUrl(modelName);

    // Cache match for SPA navigation
    sessionStorage.setItem(MATCH_KEY, JSON.stringify({ n: modelName, u: redirectUrl }));
    showForModel(modelName, redirectUrl);
  }

  // ── Init: check session cache first ──────────────────────
  var cached = sessionStorage.getItem(MATCH_KEY);
  if (cached) {
    try {
      var c = JSON.parse(cached);
      showForModel(c.n, c.u);
      return;
    } catch (e) {}
  }

  function fromUA() {
    var u = navigator.userAgent;
    var m = u.match(/;\s*([^;]+?)\s+Build\//i) || u.match(/\(([^;]+);/);
    return m && m[1] ? m[1].trim() : null;
  }

  if (navigator.userAgentData && navigator.userAgentData.getHighEntropyValues) {
    navigator.userAgentData.getHighEntropyValues(["model"])
      .then(function (u) { detect(u.model || fromUA()); })
      .catch(function ()  { detect(fromUA()); });
  } else {
    detect(fromUA());
  }

})();
